import * as React from "react"
import { guid } from './../../../utils/commons';
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { MenuItem } from '../../menu/menuitem';

export interface SaveConfirmedProps {
    savedSuccess: boolean;
    close?: () => void;
}

export class SaveConfirmed extends React.Component<SaveConfirmedProps>{
    constructor(props) {
        super(props);
    }

    onOpen() {
        setTimeout(() => this.props.close(), 250);
    }

    render() {

        if (this.props.savedSuccess === undefined || this.props.savedSuccess == null || !this.props.savedSuccess) {
            return (<React.Fragment></React.Fragment>);
        }

        return (
            <React.Fragment>
                <Modal onOpened={() => this.onOpen()} className="bg-dark" isOpen={this.props.savedSuccess} toggle={() => this.props.close()} backdrop="static">
                    <ModalHeader className="text-eurorounders bg-dark text-uppercase" toggle={() => this.props.close()}>OK</ModalHeader>
                    <ModalBody className="bg-dark text-eurorounders modal-header-button-box">
                        <div>
                            Salvataggio completato con successo
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <MenuItem isSmall={true} isButton={true} icon="times" label="ok" onClick={() => this.props.close()} />
                    </ModalFooter>
                </Modal>
            </React.Fragment>
        )
    }
}